import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { joApi, joErr } from '@/services/processingJoApi';

/** Supervisor approves / rejects a Processing Inward return check (remark required). */
export const DecideCheckDialog = ({ ck, approve, onClose, onDone }) => {
  const [remarks, setRemarks] = useState('');
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await joApi.decideCheck(ck.check_id, approve, remarks.trim());
      toast.success(`${ck.check_id} ${approve ? 'approved' : 'rejected'}`);
      onDone(r);
    } catch (e) { toast.error(joErr(e, 'Could not save')); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!ck} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="rc-decide-dialog">
        <DialogHeader><DialogTitle>{approve ? 'Approve' : 'Reject'} {ck?.check_id}</DialogTitle>
          <DialogDescription>{approve ? 'Processing Inward can then save this bundle as counted.' : 'The bundle stays blocked until the pieces / sort no / colour are corrected.'}</DialogDescription></DialogHeader>
        <Textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder={approve ? 'Why is it OK? e.g. jobber returned 2 pcs from the earlier lot' : 'Why is it rejected?'} data-testid="rc-decide-remarks" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="rc-decide-cancel">Cancel</Button>
          <Button onClick={go} disabled={busy || !remarks.trim()} className={approve ? 'bg-emerald-600 hover:bg-emerald-700 text-white' : 'bg-rose-600 hover:bg-rose-700 text-white'} data-testid="rc-decide-confirm">
            {busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}{approve ? 'Approve' : 'Reject'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DecideCheckDialog;
